/**
 * When non-null, show AccountAvatarPlaceholder instead of a user photo.
 * @param {object|null|undefined} user — wiersz z `public.users` lub null, gdy RLS nie zwraca profilu
 * @returns {'inactive' | 'banned' | null}
 */
export function getAccountAvatarPlaceholderVariant(user) {
  if (!user) return 'inactive';
  if (user.is_banned === true) return 'banned';
  if (user.is_active === false) return 'inactive';
  return null;
}
